@if (isLoading()) {
  <div class="h-[210px] w-full rounded-(--taskcard-border-radius) bg-(--p-surface-200) animate-pulse"></div>
} @else if (hasError()) {
  <div class="flex flex-col gap-6 p-6 rounded-(--taskcard-border-radius) bg-(--p-surface-0)">
    <app-feedback [config]="errorFeedbackConfig()" />
    <app-button
      [config]="errorButtonConfig()"
      (onClick)="onRetry()"
    />
  </div>
} @else {
  <app-task-card
    [config]="taskCardConfig()"
    (buttonClick)="onButtonClick()"
  />
}
